const o = {
  name: "Australia",
  dimensions: { width: 20, height: 12 },
  content: `
    <g>
      <path d="M17.1349 10.4795C16.6649 10.4795 16.1949 10.2995 15.8349 9.93951L11.5649 5.66951C10.6849 4.78951 9.2549 4.78951 8.3849 5.66951L4.1649 9.89951C3.4449 10.6195 2.2849 10.6195 1.5649 9.89951C0.844902 9.17951 0.844902 8.01951 1.5649 7.29951L5.7849 3.07951C8.0949 0.769514 11.8649 0.759514 14.1749 3.07951L18.4349 7.33951C19.1549 8.05951 19.1549 9.21951 18.4349 9.93951C18.0749 10.2995 17.6049 10.4795 17.1349 10.4795Z" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M3.1748 5.94946L5.2248 7.99946" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M5.04492 4.08948L7.09492 6.12948" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M16.8249 5.94946L14.7749 7.99946" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M14.9548 4.08948L12.9048 6.12948" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
  `
};
export {
  o as Australia
};
